import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  private errorListener = new Subject();

  getErrorListener() {
    return this.errorListener.asObservable();
  }

  throwError(message: any) {
    this.errorListener.next(message);
    if (message || message !== "") {
      this.errorListener.next(message);
    } else {
      this.errorListener.next("An Unknown Error occurred");
    }
  }

  handleError() {
    this.errorListener.next(null);
  }
}
